import { Link} from "react-router-dom";
import { Image } from "react-bootstrap";


const FeaturedCategories = () => {
  const featuredCategories = [
    {
      name: "Microcontrollers",
      link: "Microcontrollers",
      image: "./img/icons/microcontrollers.png",
    },
    {
      name: "Capacitors",
      link: "Capacitors",
      image: "./img/icons/capacitor.png",
    },
    {
      name: "Inductors",
      link: "Inductors",
      image: "./img/icons/inductors.png",
    },
    {
      name: "Resistors",
      link: "Resistors",
      image: "./img/icons/resistor.png",
    },
    {
      name: "Diodes",
      link: "Diodes",
      image: "./img/icons/diodes.png",
    },
    {
      name: "Sensors",
      link: "Sensors",
      image: "./img/icons/sensors.png",
    },
    {
      name: "Relays",
      link: "Relays",
      image: "./img/icons/relays.png",
    },
    {
      name: "Connectors",
      link: "Connectors",
      image: "./img/icons/connectors.png",
    },
  ];

  return (
    <section className="featured-section featured-categories-section">
      <div className="header-section">
        <h2 className="text-xl font-semibold mb-4">Featured Categories</h2>
        <Link to="/products" className="text-blue-500 hover:underline">
          View all Categories
        </Link>
      </div>
      <div className="body-section grid grid-cols-2 md:grid-cols-4 gap-6">
        {featuredCategories.map((category, index) => (
          <div
            key={index}
            className="featured-category bg-white rounded-lg shadow-md p-4 flex items-center justify-center flex-col"
          >
            <Link to={`/products?category=${category.link}`}>
              <Image src={category.image} alt={category.name} />
            </Link>
            <h3 className="mt-2 text-lg font-medium">
              <Link to={`/products?category=${category.link}`}>
                {category.name}
              </Link>
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedCategories;
